import { render, staticRenderFns } from "./financeiro-importacao-pagamentos.vue?vue&type=template&id=4422d022"
import script from "./financeiro-importacao-pagamentos.vue?vue&type=script&lang=ts"
export * from "./financeiro-importacao-pagamentos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports